<groundworks-modal>
  <groundworks-modal-header
    [title]="title()"
    [isCancellable]="canDismiss()"
    (cancelModal)="cancel()"
  />
  <groundworks-modal-body>
    @switch (state()) {
      @case ('success') {
        <div class="alert alert-success border-success d-flex align-items-center mb-0">
          <i class="bi bi-check-circle-fill text-success me-2"></i>
          <span>Project successfully completed.</span>
        </div>
      }
      @case ('error') {
        <groundworks-state-message type="error" [message]="errorMessage()" />
      }
      @default {
        <div class="alert alert-warning border-warning d-flex align-items-center mb-0">
          <i class="bi bi-exclamation-circle-fill text-warning me-2"></i>
          <span>Are you sure you want to mark this project complete? This action cannot be undone.</span>
        </div>
      }
    }
  </groundworks-modal-body>
  @if (footerActions().length > 0) {
    <groundworks-modal-footer [actions]="footerActions()" />
  }
</groundworks-modal>
